import React, { useEffect, useState } from "react";
import { Target } from "lucide-react";
import { api } from "@/lib/api";

const KEYS = [["swing_up", "Swing · Bullish"], ["swing_down", "Swing · Bearish"], ["intraday_up", "Intraday · Bullish"], ["intraday_down", "Intraday · Bearish"]];
const tone = (v) => (v == null ? "text-slate-500" : v >= 0 ? "text-emerald-600" : "text-rose-600");

const Cell = ({ s, testid }) => (
  <span className="flex-1 text-right" data-testid={testid}>
    {s?.n ? <><span className={s.hit_pct >= 50 ? "text-emerald-600" : "text-rose-600"}>{s.hit_pct}%</span>
      <span className="text-slate-500"> {s.hits}/{s.n} · </span><span className={tone(s.avg_move)}>{s.avg_move > 0 ? "+" : ""}{s.avg_move}%</span></> : <span className="text-slate-500">—</span>}
  </span>
);

export const GoldScorecard = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get("/today/tfr-gold/score").then((r) => setD(r.data)).catch(() => setD({ by_day: [] }));
    load();
    const id = setInterval(load, 120000);
    return () => clearInterval(id);
  }, []);
  if (!d) return null;
  return (
    <div className="border border-slate-200 bg-white" data-testid="gold-scorecard">
      <div className="flex items-center gap-1.5 px-2 h-9 text-xs font-bold font-mono border-b border-slate-200 text-amber-400">
        <Target className="h-3.5 w-3.5" /> TFR Gold Scorecard
        <span className="ml-2 text-[10px] font-normal text-slate-500">hit = close (live price today) beyond the cross price in the setup's direction · avg move from cross price · {d.sessions || 0} sessions</span>
      </div>
      <div className="flex gap-2 px-2 py-1 text-[9px] uppercase text-slate-500 font-mono border-b border-slate-200">
        <span className="w-28">Session</span>{KEYS.map(([k, l]) => <span key={k} className="flex-1 text-right">{l}</span>)}
      </div>
      {d.sessions ? (
        <>
          <div className="flex gap-2 px-2 py-1.5 text-xs font-mono font-bold border-b border-slate-300 bg-amber-400/5" data-testid="gold-score-total">
            <span className="w-28 text-slate-900">All {d.sessions}</span>{KEYS.map(([k]) => <Cell key={k} s={d.total?.[k]} testid={`gold-score-total-${k}`} />)}
          </div>
          {d.by_day.map((r) => (
            <div key={r.date} className="flex gap-2 px-2 py-1 text-xs font-mono border-b border-slate-200" data-testid={`gold-score-day-${r.date}`}>
              <span className="w-28 text-slate-700">{r.date}{r.date === d.latest ? " (live)" : ""}</span>{KEYS.map(([k]) => <Cell key={k} s={r[k]} />)}
            </div>
          ))}
        </>
      ) : <p className="p-4 text-xs font-mono text-slate-500" data-testid="gold-score-empty">Scorecard starts filling from the next market session — every TFR Gold entry is logged with its cross price.</p>}
    </div>
  );
};
